<template>
  <section
    ref="container"
    class="page-container">
    <div
      :class="{'pdb-10':showBuyQuoteContainer}"
      class="main-header ">
      <div class="flex-sb">
        <div class="">
          <div class="header-title flex">
            <span
              v-if="merchant_platform"
              class="table-icon__img icon">
              <img :src="getOptionName('serverTypeIcon',merchant_platform)" >
            </span>
            <span
              class="icon">
              <font-awesome-icon icon="dollar-sign" />
            </span>
            <span
              v-if="!isSMEProduct||isNewSME"
              class="icon">
              <v-button class="button-radius">{{detailData.type_language}}</v-button>
            </span>
            <span
              class="hcid"> <span class="number-color">{{detailData.quotation_number}}</span></span>
            <span
              class="flex flex-align-center mg-l-15">
              <font-awesome-icon
                v-if="[0,1].includes(detailData.pcy_agreement_1)"
                icon="square-check"
                class="mg-r-3 fs-12"
                :class="{'pending_verify-color':detailData.pcy_agreement_1==0,'verified-color':detailData.pcy_agreement_1==1} "></font-awesome-icon>
              <span
                class="fs-12"
                :class="{
                  'pending_verify-color': detailData.pcy_agreement_1 ==0,
                  'verified-color': detailData.pcy_agreement_1 == 1,
                }">{{getOptionName('user_agreement_option',detailData.pcy_agreement_1) }}</span>
            </span>
          </div>

          <div class="header-title flex">
            <template>
              <span
                v-tooltip="detailData.company_id>0?detailData.company_language:null"
                class="icon icon-content"
              >
                <img
                  v-if="detailData.company_id>0"
                  :src="getOptionData('companySmallIcon', detailData.company_id).logo? getOptionData('companySmallIcon', detailData.company_id).logo: detailData.company_logo"
                >
              </span>
              <span
                v-if="!isSMEProduct||isNewSME"
                v-tooltip="detailData.class_language"
                class="icon icon-content"
              >
                <font-awesome-icon
                  v-if="detailData.class_id"
                  :icon="getOptionName('iconOptions', detailData.class_id)" />
              </span>
              <span
                v-else
                class="icon icon-content"
              >
                <font-awesome-icon icon="cube"/>
              </span>
            </template>
            <h3>{{ detailData.plan }}</h3>
          </div>
          <div class="flex flex-align-center">

            <span
              v-if="!isSMEProduct||isNewSME"
              class="span-status "
              :class="getStatusColor(detailData.stts_language,'quoteStatusColor')"
            >
              {{detailData.stts_language}}
            </span>
            <span
              v-for="(val, i) in quote_tag_language"
              :key="i"
              class="span-status"
              :class="{
                'red': [1].includes(val.id),
                'black': [2,4,8].includes(val.id)
              }">
              {{val.name}}
            </span>
            <span class="header-date">Created  <span class="number-color number-fontsize">{{ detailData.created_at }}</span></span>
            <span class="header-date">Last Updated  <span class="number-color number-fontsize">{{ detailData.updated_at }}</span></span>
          </div>
        </div>
        <div class="flex">
          <div class="form-item mg-r-8">
            <span>Source</span>
            <span>
              <v-select
                v-model="detailData.ref_agency_id"
                :disabled="detailData.admin_created_id==0"
                :list="globalOptions.ref_agency"
                @change="changeDetailReferrerAgency" />
            </span>
          </div>
          <div class="form-item">
            <span>Assignee</span>
            <span>

              <v-select
                v-model="detailData.cs_id"
                icon="user-nurse"
                :list="assigneeList"
                :clearable="true"
                @change="selectAssignee"
              />
            </span>
          </div>
        </div>
      </div>

      <div
        v-if="!showBuyQuoteContainer"
        :class="editStatus?'margin-bottom':''">

        <el-tabs
          v-if="!editStatus"
          v-model="activeTab"
          @tab-click="handleChangeLog"
        >
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :label="tab.label"
            :name="tab.name"
          ></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div
      v-if="!showBuyQuoteContainer"
      class="main-container">
      <div
        v-show="showMain"
        class="main-col">
        <div class="middle-col">
          <v-serviced-progress
            v-if="merchant_platform"
            class="mg-b-20"
            :agency-name="detailData.agency_name"
            :is-fina="isFina"></v-serviced-progress>
          <detail-tab
            v-show="activeTab === '0'"
            :form="detailData"
            @edit="handlerEdit"/>
          <document-info
            v-show="activeTab === '1'"
            :inter="true"
            :form="detailData"
            @edit="handlerEdit"/>
          <premium-tab
            v-show="activeTab === '2'"
            :form="detailData"
            @edit="handlerEdit"
          />
          <tickets-tab
            v-show="activeTab === '3'"
            :form="detailData"
            @update-data="updateTicketsData"/>
          <detail-log
            v-show="activeTab == '4'"
            :logsData="logsData">
          </detail-log>
        </div>
        <div class="right-col">
          <div class="">
            <div
              v-if="detailData.is_share_guest_order && detailData.company_id == 0"
              class="unbuyable-status btn-list border-b amount-payable">
              <span class="title">No Plan Selected</span>
              <div class="button-width">
                <v-button
                  icon="th-list"
                  class="mg-t-10 button-weight"
                  @click="handlerSelectPlan()">
                  <span>Select Plan</span>
                </v-button>
                <v-button
                  icon="percent"
                  class="mg-t-10 button-weight"
                  @click="handlerSetReferrerDiscount">
                  <span>
                    Referrer Discount
                    <span
                      v-if="detailData.share_discount"
                      class="percent">{{detailData.share_discount}}%</span>
                  </span>
                </v-button>
                <v-button
                  icon="skull"
                  class="mg-t-10 button-weight"
                  :disabled="isDisableVoidQuote"
                  @click="handlerVoidQuote">
                  <span class="void-color"> Void Quote</span>
                </v-button>
              </div>
            </div>
            <div
              v-else
              v-loading="loading"
              element-loading-text="等待最終支付完成"
              element-loading-spinner="el-icon-loading"
              class="btn-list border-b amount-payable"
              :class="amountStatus"
            >
              <span class="title">Amount Payable</span>
              <div
                v-if="isRenew && !isVoidStatus&&!isNewSME"
                class="renew_list">
                <p
                  v-for="(item, i) in detailData.renew_quote_data"
                  :key="i"
                  class="flex"
                  :class="{'cursor_default': !(detailData.stts < 401 && detailData.stts >= 250)}"
                  @click="handlerSwitchInsurer(item)">
                  <span class="icon">
                    <img
                      :src="getOptionData('companySmallIcon', item.company_id).logo? getOptionData('companySmallIcon', item.company_id).logo: item.company_logo"
                    >
                  </span>
                  <span
                    class="money"
                    :class="{'active':item.id==detailData.quo_id}">{{item.amount | formatMoney(2,true)}}</span>
                  <span
                    v-show="item.id==detailData.quo_id && item.is_auto_quote"
                    class="amount_tag tag_auto">Auto</span>
                  <span
                    v-show="item.is_renew_terms"
                    class="amount_tag tag_terms">Renew Terms</span>
                </p>
                <div class="btn flex">
                  <v-button
                    v-if="(detailData.stts < 401 && detailData.stts >= 250)||[210].includes(detailData.stts)"
                    icon="exchange-alt"
                    @click="handlerSwitchInsurer"
                  >Switch Insurer</v-button>
                </div>
              </div>
              <span
                v-if="!isRenew||isNewSME"
                :style="{ fontSize: cssFontSize(detailData.amount, 220, 28) }"
                class="amount">
                <span v-if="fina_refer">TBC</span>
                <span v-else>{{ detailData.amount | formatMoney(2, true) }}</span>
              </span>
              <div
                v-if="!fina_refer"
                class="mg-b-20">
                <span
                  class="flex flex-sb-center mg-b-5">
                  <span class="color-gray2 fs-12">Main Policy Gross</span>
                  <span class="color-gray2 fs-12">{{ detailData.gross | formatMoney(2, true) }}</span>
                </span>
                <template v-if="extra_benefits_coverage.length>0">
                  <span
                    v-for="(item,index) in extra_benefits_coverage"
                    :key="'extra-'+index"
                    class="flex flex-sb-center mg-b-5">
                    <span class="color-gray2 fs-12">Extra Benefit {{index+1}}</span>
                    <span class="color-gray2 fs-12">{{ item.gross | formatMoney(2, true) }}</span>
                  </span>
                </template>
              </div>
              <template v-if="!fina_refer">
                <div
                  v-if="showVoidQuoteBtn"
                  class="payment-status">
                  <div class="flex">
                    <span
                      class="dot"
                      :class="isPaidNoSignature||isPaidSignature||isUnderlinePay?'green':''"></span>
                    <span>Payment</span>
                  </div>
                  <div
                    v-if="(isBuyable||isAjust) && !bankPay"
                    class="flex text-color hand"
                    @click="handlerBuyQuote">
                    <span class="icon">
                      <font-awesome-icon
                        icon="money-bill-wave"></font-awesome-icon>
                    </span>
                    <span>Pay on behalf</span>
                  </div>
                  <div
                    v-if="isSent"
                    class="blue pointer fs-12 fw-400"
                    @click="handleUploadPayment">Upload Payment</div>
                  <span
                    v-if="isPaidNoSignature||isPaidSignature"
                    class="size-italic">Paid</span>
                  <span
                    v-if="isUnbuyableLock||isUnbuyable"
                    class="size-italic">Quote Info Incomplete</span>
                </div>
                <div
                  v-if="showVoidQuoteBtn&&!isAjust"
                  class="payment-status payment-disblock">
                  <div class="flex flex-sb">
                    <div class="flex">
                      <span
                        class="dot"
                        :class="isPaidSignature||isSignature?'green':''"></span>
                      <span>Signature</span>
                    </div>
                    <span
                      v-if="isPaidNoSignature"
                      class="size-blue"
                      @click="handlerSkip">
                      Skip
                    </span>
                  </div>
                </div>

                <div
                  v-if="bankPay"
                  class="tips">{{tipsText}}</div>

                <div
                  v-if="showVoidQuoteBtn&&!isPaidSignature && !bankPay"
                  class="flex button-list">
                  <v-button
                    size="small"
                    icon="link"
                    :disabled="isUnbuyableLock"
                    @click="handlerSend"
                  ><span :class="isUnbuyableLock?'':'send-color'">{{payText}}</span>
                  </v-button>
                  <v-button
                    :disabled="isUnbuyableLock"
                    @click="handlerContact(1)"
                  >
                    <font-awesome-icon icon="sms"></font-awesome-icon>
                  </v-button>
                  <v-button
                    :disabled="isUnbuyableLock"
                    @click="handlerContact(3)"
                  >
                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                  </v-button>
                </div>
              </template>
              <div
                v-if="fina_refer"
                class="button-width">
                <v-button
                  gray
                  class="button-weight"
                  icon="plus"
                  @click="handleCreateRefer">Create Refer Case</v-button>
              </div>
              <div
                v-if="showVoidQuoteBtn"
                class="button-width">
                <template v-if="!fina_refer">
                  <div
                    v-if="bankPay"
                    class="bank-pay">
                    <div class="tr">
                      <v-button
                        v-if="detailData.stts == 260"
                        icon="link"
                        class="blue button-weight mg-r-8"
                        @click="handlerSend('bankPay')">Copy Upload Link</v-button>
                      <v-button
                        v-if="detailData.stts == 260"
                        @click="bankTransferSms">
                        <font-awesome-icon icon="sms"></font-awesome-icon>
                      </v-button>
                    </div>
                    <v-button
                      v-if="detailData.stts == 260"
                      icon="upload"
                      gray
                      class="button-weight"
                      @click="handleUploadProof">Upload Payment Proof</v-button>
                    <v-button
                      v-if="detailData.stts == 270"
                      icon="magnifying-glass-dollar"
                      green
                      class="button-weight success"
                      @click="handleReview">Review</v-button>
                  </div>
                  <v-button
                    v-if="isShowApplication"
                    icon="download"
                    gray
                    class="mg-t-10 button-weight"
                    @click="handleDwonApplication">Application Form
                  </v-button>
                  <v-button
                    v-if="[210,250].includes(detailData.stts) && isFina"
                    gray
                    class="mg-t-10 button-weight"
                    @click="handleFinaQuoteReady">Quote Ready To
                  </v-button>
                  <template>
                    <div
                      v-if="(!isPaidNoSignature&&!isAjust&&!isPaidSignature)&&!isGuest&&!isNewSME"
                      class="flex-sb-center mg-b-20">
                      <span class="fs-14 color-dark fw-600">Customer Editable</span>
                      <v-text-switch
                        v-model="is_lock"
                        :active-value="0"
                        :inactive-value="1"
                        @change="handlerLock"></v-text-switch>
                    </div>
                    <div
                      v-if="isRenew && !isPaidSignature"
                      class="flex-sb-center mg-b-20">
                      <span class="fs-14 color-dark fw-600">Renew Reminders</span>
                      <v-text-switch
                        v-model="detailData.renewal_remind"
                        @change="remindCustomer"></v-text-switch>
                    </div>
                  </template>
                  <v-button
                    v-if="isShowDiscount"
                    size="small"
                    gray
                    class="mg-t-10 button-weight"
                    icon="funnel-dollar"
                    :disabled="isVoidStatus"
                    @click="openDialog('manual-dialog')"
                  ><span class="">Set Discount/Admin Charge</span>
                  </v-button>
                  <div
                    v-if="isRenew&&!isSMEProduct||isDownloadPDF&&!isRenew&&!isSMEProduct"
                    class="flex flex-align-center">
                    <v-button
                      size="small"
                      gray
                      class="mg-t-10 button-weight"
                      icon="file-pdf"
                      @click="openRenewPdf"
                    > <span class="">Quotation</span>
                    </v-button>
                    <span
                      class="flex mg-l-8 text-color fs-12 blue hand"
                      @click="handleRebuild()">Rebuild</span>
                  </div>
                  <div
                    v-if="isDownloadInvoicePDF"
                    class="flex flex-align-center">
                    <v-button
                      size="small"
                      gray
                      class="mg-t-10 button-weight"
                      icon="file-pdf"
                      @click="openInvoicePdf"
                    > <span class="">Invoice</span>
                    </v-button>
                    <span
                      class="flex mg-l-8 text-color fs-12 blue hand"
                      @click="handleRebuild('inv_pdf_path')">Rebuild</span>
                  </div>
                  <!--                  <v-button-->
                  <!--                    v-if="(!isPaidNoSignature&&!isAjust&&!isPaidSignature)&&!isGuest&&!isNewSME"-->
                  <!--                    size="small"-->
                  <!--                    gray-->
                  <!--                    :icon="isBuyableLock||isUnbuyableLock?'unlock':'lock'"-->
                  <!--                    class="mg-t-10 button-weight"-->
                  <!--                    @click="handlerLock(detailData.is_lock)"-->
                  <!--                  >-->
                  <!--                    {{ isBuyableLock||isUnbuyableLock?'Unlock':'Lock'}} Customer Editing-->
                  <!--                  </v-button>-->
                </template>
                <v-button
                  v-if="showVoidQuoteBtn&&!isPaidSignature"
                  icon="skull"
                  gray
                  :disabled="isDisableVoidQuote"
                  class="mg-t-10 button-weight"
                  @click="handlerVoidQuote">
                  <span class="void-color"> Void Quote</span>
                </v-button>
                <template v-if="!fina_refer">
                  <v-button
                    v-if="isPaidSignature"
                    icon="file-powerpoint"
                    class="mg-t-10 button-weight green"
                    @click="handlerVeiwPolicy">
                    <span> View Policy</span>
                  </v-button>
                </template>
              </div>
              <span
                v-else
                :class="{'mt-10': isRenew}"
                class="void-color">
                This quote has been voided.
              </span>
            </div>
            <div class="box">
              <span class="title">Support</span>
              <div class="button-width">
                <v-button
                  icon="plus"
                  class="button-weight"
                  @click="openDialog('new-general-ticket')">New General Ticket
                </v-button>
              </div>
              <div
                v-if="(!isGuest||isGuest&&isVoidStatus)&&!isNewSME"
                class="button-width">
                <v-button
                  icon="copy"
                  class="mg-t-10 button-weight"
                  @click="onCopyKyc"
                >
                  Copy KYC
                </v-button>
              </div>
            </div>
            <template   v-if="!isRenew && detailData.plan_id">
              <right-plan-info
                :detail-data="detailData"
                @view="viewPlan"></right-plan-info>
            </template>
            <template v-if="isRenew">
              <right-policy-info
                :detail-data="detailData"
                :pre-policy-info="prePolicyInfo"></right-policy-info>
            </template>
            <template v-if="!isFina">
              <div
                v-if="detailData.customer_id<=0"
                class="box">
                <div class="flex-sb">
                  <span class="title fs-14 fw-600 mg-b-10">Customer</span>
                </div>
                <span class="flex-align-center">
                  <i class="el-icon-user fs-16 fw-600 gray mg-r-8"></i>
                  <span class="fs-14 fw-600 gray">Without Account</span>
                </span>
              </div>
              <template v-else>
                <right-customer-detail
                  :detail-data="detailData"
                  can-customer-add
                  :show-customer="detailData.customer_id>0"
                  :customer-profile="customer_profile"
                  is-quote
                  @attach="handlerAttach"
                  @view="viewCustomer"
                  @share="handlerShare"
                  @unShare="handleUnShare"
                  @editDes="editDescription"></right-customer-detail>
              </template>
            </template>
          </div>
          <edit-summary
            v-if="isSMEProduct"
            :inter-summary="detailData.inter_summary"
            :order-id="orderId"
            @update="handler().getUpdateData(0)"></edit-summary>
          <right-remark
            :remark="remarkList"
            is-quote
            :quo-id="detailData.quo_id"></right-remark>
        </div>
      </div>
      <div
        v-if="!showMain"
        class="main-edit flex-1">
        <detail-form
          v-show="editStatus"
          ref="detailForm"
          :form="detailData"
          :editStatus="editStatus"
          @refresh="handleUpdateDetail"
          @update="handler().getUpdateData(0)"
          @cancel="handler().handlerCancel(0)"
          @save="handler().getUpdateData(0)"/>
        <quote-buy
          v-if="showPayment"
          :orderId="orderId"
          :isNewSME="isNewSME"
          :customerId="customerId"
          :formData="detailData"
          :customer-profile="customer_profile"
          :customer="customer"
          @cancel="handler().handlerCancel(0)"/>
      </div>
    </div>

    <section
      v-if="showBuyQuoteContainer"
      class="main-container">
      <buy-quote
        :referDetail="detailData"
        :isRenew="detailData.type == 20"
        :orderId="detailData.id"
        :customer-profile="customer_profile"
        :is-refer="true"
        :is-fina="isFina"
        :customerId="detailData.customer_id"
        @back="handler().handleBack()"  />
    </section>

    <div v-if="showKyc">
      <renew-edit-kyc
        v-if="!isNewSME"
        ref="edit-kyc"
        :editType="3"
        :is-fina="isFina"
        :customerId="detailData.customer_id"
        :hasEndorsNum="hasEndorsNum"
        :hasClaimNum="pre_unsettled_claims.length > 0"
        :form="detailData"
        :addRenew="false"
        :fromQuote="true"
        @update="handleUpdateDetail"
        @nextStep="nextStep"
        @reply-all="handlerSave"
        @cancel="cancelEdit"></renew-edit-kyc>
      <div
        v-else
        class="pd-40">
        <edit-sme-kyc
          :form="detailData"
          :customerId="customerId"
          is-quote
          :is-fina="isFina"
          :remark="remarkList"
          is-renew-quote
          @save-success="handlerSave"
          @refresh="handlerSave"
          @reply-all="handlerSave"
          @reply-complete="handlerSave"
          @cancel="cancelEdit" />
      </div>
    </div>

    <to-top
      v-if="!showMain"
      :el='container'></to-top>

    <!-- dialog -->
    <new-general-ticket
      ref="new-general-ticket"
      :customer="customer"
      :form="ticketParams"/>
    <void-quote
      ref="void-quote"
      :orderId="orderId"
      @done="handler().updateQuoteDetailData(0)"/>

    <plan-dialog
      ref="plan-dialog"
      :planInfo="detailData.quote_coverage_list"/>
    <edit-account
      ref="editAccount"
      :form="detailData"
    ></edit-account>
    <contact-dialog
      ref="contact-dialog"
      :type="contactType"
      :ticketId="detailData.ticketId"
      :initPhone="detailData.phone"
      :initEmail="detailData.email"
      :customerData="customerData"
      :initCustomerId="customerId"
      :shareLink="detailData.url_data"
    />
    <set-manual-dialog
      ref="manual-dialog"
      :orderId="orderId"
      :form="detailData"
      :is-fina="isFina"
      :is-sme="isSMEProduct"
      :is-amount="isSMEProduct"
      @saveManual="saveManual">
    </set-manual-dialog>
    <set-void-quote
      ref="void-dialog"
      :orderId="orderId"
      @setVoid="handlerVoid"
    >
    </set-void-quote>

    <send-email-sms
      ref="send-email-sms"
      :form="detailData"
      :type="contactType == 1? 1: 2"
      :initContent="detailData.url_data"
      :init-refer-content="detailData.referrer_url_data"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      :is-fina="isFina"
      @send="handlerEmailSmsSend"
      @skip="handlerEmailSmsSkip" />
    <attach-customer
      ref="attachCustomer"
      :isShare="detailData.is_share_guest_order==1"
      :form="detailData"
      :orderId="orderId"
      @addCustomer="handlerCustomer"
    >
    </attach-customer>
    <endors-renew-tips
      ref="endors-tips"
      :endorseNumber="detailData.pre_endorsement_ticket_number"
      @continue="tipsContinue"></endors-renew-tips>
    <endors-renew-tips
      ref="claim-tips"
      :cliams="pre_unsettled_claims"
      @continue="tipsContinue"></endors-renew-tips>

    <plan-dialog
      ref="plan-dialog"
      :planInfo="detailData.quote_coverage_list"
      @get-reference-quote="getReferenceQuote" />

    <set-referrer-discount
      ref="set-referrer-discount"
      :classId="detailData.class_id"
      :form="detailData"

      @setReferrerDiscount="setReferrerDiscount"></set-referrer-discount>

    <bank-transfer-sms
      ref="bank-transfer-sms"
      :form="detailData"></bank-transfer-sms>

    <upload-bank-file
      ref="upload-bank-file"
      :orderId="isSMEProduct?detailData.order_id:detailData.id"
      @review="handleReview"
      @update="handler().updateQuoteDetailData(0)"></upload-bank-file>

    <review-payment
      ref="review-payment"
      :orderId="isNewSME?orderId:detailData.id"
      :detail="detailData"
      :isNewSME="isNewSME"
      @update="handler().updateQuoteDetailData(0)"></review-payment>
    <attach-user
      ref="attach-user"
      :is-share="true"
      @shareUser="handleShareCustomerId"
    />
    <edit-description
      ref="edit-description"
      :detailData="customer_profile"
      :customerId="customerId"
      @update="getUpdateAccountData"></edit-description>
    <edit-description
      ref="edit-share-description"
      :detailData="shareInfo"
      :customerId="shareInfo.id"
      @update="handleUpdateDetail"></edit-description>
    <send-contact-dialog
      v-model="showSMS"
      :form="detailData"
      :contact-type="contactType"
      is-quote
      :is-fina="isFina"
    ></send-contact-dialog>
  </section>
</template>

<script>
import sendContactDialog from '@/views/sme/components/send-contact-dialog'
import DetailTab from './components/detail-tab'
import DetailForm from './components/detail-form'
import QuoteBuy from './components/quote-buy'
import PremiumTab from './components/premium-tab'
import DocumentInfo from '@/views/tickets/components/document-info'
import TicketsTab from './components/tickets-tab'
import PlanDialog from '@/views/quoting/dialogs/plan-dialog'
import EditAccount from '../../accounts/components/editAccount'
import ContactDialog from '@/views/tickets/dialogs/contact-dialog'
import setManualDialog from '@/views/components/set-manual-dialog'
import setVoidQuote from '@/views/components/set-void-quote'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import attachCustomer from '../quote/components/dialog/attachCustomer'
import endorsRenewTips from '@/views/components/dialogs/endors-renew-tips'
import rightCustomerDetail from '@/views/components/right-customer-detail'
import rightPlanInfo from '@/views/components/right-plan-info'
import rightRemark from '@/views/components/right-remark'
import rightPolicyInfo from '@/views/components/right-policy-info'
import {
  getCoressQuoteDetail,
  getQuoteReference,
  getQuoteUrl,
  orderCsSet,
  orderSkip,
  paymentLinkSend,
  setDiscount,
  signLinkSend,
  downReferApplication,
  quoteSentStatus
} from '@/api/quote'
import {getOrderLogList, RebuildPDF, setLockCustomer} from '@/api/order'
import {getShareGuestQuote, getUrlData, removeShareUserPolicy, shareUserPolicy} from '@/api/share'
import NewGeneralTicket from '@/views/tickets/dialogs/new-general-ticket'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinPolicyholderDetail from '@/mixins/policyholader-detail'
import {addAccountRemark, getAccountDetail} from '@/api/account'
import VoidQuote from './components/dialog/void-quote'
import {mapActions, mapState} from 'vuex'
import detailLog from '@/views/components/log/detail-log'
import {getSMEQuoteDetail} from '@api/sme'
import BuyQuote from '@/views/tickets/components/buy-quote'
import {renewBuyPolicy, renewRemind} from '@/api/renewal'
import renewEditKyc from '@/views/tickets/components/edit-refer-case'
import {downloadFile} from '@/utils/download'
import SetReferrerDiscount from './components/dialog/set-referrer-discount'
import BankTransferSms from './components/dialog/bank-transfer-sms'
import UploadBankFile from './components/dialog/upload-bank-file'
import ReviewPayment from './components/dialog/review-payment'
import AttachUser from '@/views/quoting/dialogs/attachCustomer'
import EditDescription from '@/views/accounts/dialog/edit-description'
import EditSmeKyc from '@/views/sme/components/edit-sme-kyc'
import {getNewSMEQuoteDetail } from '@api/new_sme'
import {getQuoteAllNew } from '@api/quote'
import RightPlanInfo from '@/views/components/right-plan-info'
import RightRemark from '@/views/components/right-remark'
import {addReferral} from '@/api/refer'
import EditSummary from '@/views/sme/components/edit-summary'
export default {
  name: 'QuoteDetail',
  components: {
    EditSummary,
    RightRemark,
    RightPlanInfo,
    DetailTab,
    DetailForm,
    QuoteBuy,
    DocumentInfo,
    TicketsTab,
    PremiumTab,
    NewGeneralTicket,
    VoidQuote,
    PlanDialog,
    EditAccount,
    ContactDialog,
    setManualDialog,
    setVoidQuote,
    SendEmailSms,
    attachCustomer,
    detailLog,
    BuyQuote,
    renewEditKyc,
    endorsRenewTips,
    SetReferrerDiscount,
    BankTransferSms,
    UploadBankFile,
    ReviewPayment,
    AttachUser,
    EditDescription,
    EditSmeKyc,
    sendContactDialog,
    rightCustomerDetail,
    rightPlanInfo,
    rightRemark,
    rightPolicyInfo,
  },
  mixins: [MixinOptions, MixinFormat,MixinPolicyholderDetail],
  data() {
    return {
      showSMS: false,
      is_lock: 0,
      customer_profile: {},
      contianer: null,
      orignal_cs: '',
      isPlan: false,
      contactType: 0,
      detailData: {
        customer: {},
      },
      showMain: true,
      editStatus: false,
      showPayment: false,
      activeTab: '0',
      tabList: [
        {
          label: 'Quote Info',
          name: '0'
        },
        {
          label: 'Documents',
          name: '1'
        },
        {
          label: 'Premium & Coverage',
          name: '2'
        },
        {
          label: 'Support Tickets',
          name: '3'
        },
        {
          label: 'Log',
          name: '4'
        }
      ],
      remarkList: [],
      message: '',
      clearTime: '',
      loading: false,
      paymentQuoteTimer: null,
      logsData:[],
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      emailListTitle: '',
      emailTitle: '',
      selectPlan:false,
      showBuyQuoteContainer: false,
      showKyc: false,
      step: 1,
      quoteUrl: '',
      form11: {
        brand_id: '',
        model_id: '',
        typ_of_bdy_id: '',
        engn_cpcty: '',
        rgtn_yr: '',
        ncd_pct: '',
        benefits: [],
        trm_of_cvr: 1,
        isrd_vl: '',
        no_of_nm_drvr: 1,
        nm_drvr_list:[
          {
            nm_drvr_age:'',
            nm_drvr_exp:'',
            nm_drvr_acc:'',
            nm_drvr_pt:''
          }
        ],
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        enough_age_ind: '',
        enough_exp_ind: '',
      },
      form12: {
        brand_id: '',
        tonnage: '',
        typ_of_bdy_mix_id : '',
        rgtn_yr: '',
        ncd_pct: '',
        benefits: [],
        trm_of_cvr: 0,
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        isrd_vl: '',
        nm_drvr_list:[
          {
            nm_drvr_age:'',
            nm_drvr_exp:'',
            nm_drvr_acc:'',
            nm_drvr_pt:''
          }
        ],
        enough_age_ind: '',
        enough_exp_ind: '',
        use_carrying_profit_ind: ''
      },
      form14: {
        trm_of_cvr: 1,
        brand_id: '',
        typ_of_bdy_id: '',
        engn_cpcty: '',
        rgtn_yr: '',
        ncd_pct: '',
        usage_ind: '',
        no_of_nm_drvr: 1,
        nm_drvr_list:[
          {
            nm_drvr_age:'',
            nm_drvr_exp:'',
            nm_drvr_acc:'',
            nm_drvr_pt:'',
          }
        ],
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        enough_age_ind: '',
        nm_drvr_age: '',
        dr_lic_of_own: ''
      },
      form21: {
        duty_id: '',
        nature: '',
        nationality_id: '',
        domestic_age: '',
        period_of_cvr: '',
        monthly_salary: '',
        coverage_id: '',
        plan_tier: 1,
        benefits: [],
      },
      form22: {
        plan_tier: 1
      },
      form23: {
        plan_type: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        class_type: 1,
        no_of_traveler:'',
        no_of_child:'',
        area_of_travel :'',
        no_of_adult:'',
        plan_tier: 1
      },
      form24: {
        contr_prd: '',
        bldg_age: '',
        tol_contr_sum: '',
        mat_dam_cvr_ind: '',
        tp_lia_cvr_ind: '',
        tppd_limit_amt: '',
        outdoor_wk_ind: '',
        scaffolding_wk: 0,
        outdoor_wk_sum: '',
        employee_ind: '',
      },
      form25: {
        country_id: '',
        is_full_time: '',
        student_age:'',
        plan_tier: 1
      },
      form26: {
        prop_insured: '',
        bldg_typ: '',
        floor_area: '',
        coverage_id: '',
        prop_age: '',
        plan_tier: 1,
        benefits: []
      },
      form27: {
        age_id: '',
        occ_id: '',
        plan_tier: 1
      },
      form29: {
        prop_insured: '',
        bldg_typ: '',
        floor_area: '',
        prop_age: '',
        bsc_sum_insured:'',
        benefits: []
      },
    }
  },
  computed: {
    ...mapState('quote',['isBack']),
    ...mapState('account', ['customerId']),
    ...mapState('ticket', ['refreshPage']),
    isHzmb(){
      let {class_id} = this.detailData||{}
      return class_id==15
    },
    isDownloadPDF(){
      let {stts} = this.detailData||{}
      return [250,240].includes(stts)
    },
    isDownloadInvoicePDF(){
      let {stts} = this.detailData||{}
      return [250,240].includes(stts)
    },
    isFina(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform==2
    },
    merchant_platform(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform
    },
    extra_benefits_coverage(){
      let {extra_benefits_content={}} = this.detailData||{}
      let arr = []
      Object.keys(extra_benefits_content).some(key=>{
        arr.push(extra_benefits_content[key].gross)
      })
      return arr||[]
    },
    customer_description(){
      let str = this.customer_profile.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    share_customer_description(){
      let str = this.shareInfo.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    shareInfo(){
      let {share_user_infos} = this.detailData||{}
      return share_user_infos||{}
    },
    productId() {
      return this.$route.query.product_id || 11
    },
    isSMEProduct(){
      let {product_id=11} = this.$route.query||{}
      return product_id>=80
    },
    isNewSME(){
      let {sme_versions} = this.detailData||{}
      return sme_versions==3
    },
    orderId() {
      return this.$route.query.order_id
    },
    customerId() {
      const { customer_id} = this.detailData
      return customer_id
    },
    ticketParams() {
      const {cs_id, customer_id, pcy_no, quotation_number, pcy_id,isrd_nm} = this.detailData
      return {
        assignee_id: cs_id,
        customer_id,
        policy_no: pcy_no,
        quote_no: quotation_number,
        pcy_id,
        isrd_nm
      }
    },
    showVoidQuoteBtn() {
      return this.detailData.stts != 0
    },
    isVoidStatus() {
      return this.detailData.stts == 0
    },
    amountStatus(){
      if(this.detailData.stts == 0)  return 'void-status'
      else if (this.isPaidSignature || (this.isRenew && this.isPayment)) return 'paid-status'
      else if(this.isUnbuyable||this.isUnbuyableLock || this.detailData.renewal_remind == 0 || this.bankPay) return 'unbuyable-status'
      else return ''
    },
    customerData(){
      return{
        contact_phone:this.detailData.phone,
        contact_email:this.detailData.send_email
      }
    },
    payText(){
      if(this.isUnbuyable||this.isUnbuyableLock) return 'Continue'
      else if(this.isPaidNoSignature) return  'Signature'
      else if(this.isAjust) return  'Payment'
      else
        return 'Pay + Sign'
    },
    isAjust(){
      return this.detailData.type==50
    },
    isBuyable(){
      const {stts} = this.detailData
      return stts<401&&(stts>=250||[210,220].includes(stts))
    },
    isUnbuyable(){
      const {stts,is_lock} = this.detailData
      return  stts!=0&&stts<=201&&is_lock==0
    },
    isUnbuyableLock(){
      const {stts,is_lock} = this.detailData
      return stts!=0&&stts<=201&&is_lock==1
    },
    isSent(){
      const {stts,is_lock} = this.detailData
      return stts==240
    },
    isPaidNoSignature(){
      const {stts,is_signature} = this.detailData
      return stts>=401&&is_signature==0
    },
    isPaidSignature(){
      const {stts,is_signature} = this.detailData
      return stts>=401&&is_signature==1
    },
    isUnderlinePay(){
      const {stts,pcy_id} = this.detailData
      return stts==270&&pcy_id!=0
    },
    isShowDiscount(){
      const {stts, quo_id} = this.detailData
      return quo_id>0 && stts<401&& ![260,270,240].includes(stts)
    },
    isShowApplication(){
      const {stts, is_share_guest_order} = this.detailData
      return is_share_guest_order==1 && stts>=210
    },
    isSignature(){
      const {is_signature} = this.detailData
      return is_signature==1
    },
    avt_pic(){
      const {avatar_pic={}} = this.detailData
      return avatar_pic&&avatar_pic.url||''
    },
    isPayment() {
      const { stts } = this.detailData
      return stts >= 401
    },
    isShowName(){
      let {customer,id_type} = this.detailData
      if(customer.isrd_nm)
        return customer.isrd_nm.trim()!=''
      else return  false
    },
    isGuest(){
      let {customer} = this.detailData||{}
      return (customer==[]||customer==null||customer=='')&&!this.isFina
    },
    customer(){
      let {customer={}} = this.detailData||{}
      return this.isGuest?{}:customer
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    isRenew(){
      let {type} = this.detailData||{}
      return type == 20
    },
    renewQuoteData(){
      return this.detailData.renew_quote_data || []
    },
    showSwitchTag(){
      let res = false
      this.renewQuoteData.map(item => {
        if(this.detailData.quo_id == item.id && item.is_renew_terms != 1){
          res = true
        }
      })
      return res
    },
    prePolicyInfo(){
      return this.detailData.pre_policy_info || {}
    },
    hasEndorsNum(){
      return typeof this.detailData.endorsement_ticket_number == 'string' && this.detailData.endorsement_ticket_number != ''
    },
    quote_tag_language(){
      return this.detailData.quote_tag_language || []
    },
    tipsText(){
      const {stts,prop_pdf} = this.detailData
      let text = ''
      if(stts == 260){
        text = 'This quote is waiting for payment proof from bank transfer.'
      }
      if(stts == 270){
        text = prop_pdf?'This quote’s bank transfer payment and application form are pending approval.':'This quote’s bank transfer payment is pending approval.'
      }
      return text
    },
    bankPay(){
      return [260, 270].includes(this.detailData.stts)
    },
    fina_refer(){
      let {amount} = this.detailData||{}
      return amount == 'TBC'
    },
    isGuestTravel(){
      let {is_guest_order} = this.detailData||{}
      return is_guest_order==1
    },
    isDisableVoidQuote() {
      let {is_refer_order,stts} = this.detailData
      return is_refer_order==1&&stts<401
    },
    pre_unsettled_claims(){
      let {pre_unsettled_claims=[]} = this.detailData||{}
      return pre_unsettled_claims||[]
    }
  },
  watch:{
    // 刷新頁面數據
    refreshPage(val, old) {
      if(val > old) {
        let that = this
        setTimeout( ()=>{
          that.handler().initStatusUpdateData()
        },500)
      }
    },
    customerId:{
      immediate:true,
      handler(val){
        if(val)
          this.network().getAccountDetail({customer_id:val})
      }
    },
  },
  created() {
    this.initData()
    this.setProductId(this.productId) // 存儲 product id，方便後續頁面用到
    this.handler().getUpdateData()

    const { origin } = this.$route.query
    if(origin == 'payment') {
      this.clearTime = Date.now()/1000
      this.handler().deepQuoteDetail()
    }

    if (this.isBack) {
      this.handlerEdit()
      setTimeout( ()=>{
        this.$refs.detailForm.handlerNext()
      },1500)
    }
  },
  mounted(){
    this.setReferData(null)
    this.container = this.$refs['container'].parentElement
  },
  destroyed() {
    clearInterval(this.paymentQuoteTimer)
  },
  methods: {
    ...mapActions('common', ['setProductId','setCarClassId']),
    ...mapActions('coupon', ['setCouponData']),
    ...mapActions('quote', ['setAllQuote', 'setQuoteForm', 'setQuoteResult']),
    ...mapActions('smeQuote', ['setEstimatedPremium','setSmeQuickForm']),
    ...mapActions('ticket', ['setReferData']),
    ...mapActions('account', ['setCustomerId', 'setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    async handleUploadPayment(){
      await this.network().quoteSentStatus({order_id:this.orderId})
      this.handler().getUpdateData()
    },
    handleRebuild(type){
      let params ={order_id: this.orderId,type:this.isDownloadPDF&&!this.isRenew?'quotation_pdf_path':'renew_file_path'}
      if(type){
        params.type = type
      }
      this.network().RebuildPDF(params)
    },
    handleCreateRefer(){
      this.network().addReferral(this.detailData)
    },
    handleDwonApplication(){
      this.network().downReferApplication()
    },
    handleFinaQuoteReady(){
      this.$router.push({
        path: '/quoting/referrer/send/payment',
        query: {
          ...this.$route.query
        }
      })
    },
    getUpdateAccountData() {
      this.network().getAccountDetail({customer_id:this.customerId})
    },
    editDescription(name){
      this.$refs[name].changeDialog()
    },
    handleUnShare(){
      this.$ConfirmBox({
        message: 'Confirm don\'t share ?',
        cancelBtn:'No',
      }).then(() => {
        this.network().removeShareUserPolicy()
      })
    },
    handlerShare(){
      this.$refs['attach-user'].showAttachCustomer()
    },
    handleShareCustomerId(data){
      this.network().shareUserPolicy({share_user_id:data})
    },
    viewShareCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.shareInfo.id
        }
      })
    },
    handleChangeLog(){
      if(this.activeTab==4)
        this.network().getOrderLogList()
    },
    handlerCustomer(){
      this.handler().updateQuoteDetailData()
    },
    handlerAttach(){
      this.$refs.attachCustomer.changeDialog()
    },
    handlerSwitchInsurer(item){
      if((this.detailData.stts < 401 && this.detailData.stts >= 250)||[210].includes(this.detailData.stts)){
        if(item){
          this.network().renewSelectPlan(item)
        }else{
          this.showBuyQuoteContainer = true
        }
      }
    },
    handlerSkip(){
      this.network().orderSkip()
    },
    selectAssignee(id) {
      id = id?id:0
      orderCsSet({
        order_id: this.orderId,
        cs_id: id,
      }).then(data=>{
        this.orignal_cs = id
        this.$message({
          type: 'success',
          message: 'Success'
        })
      }).catch(err=>{
        this.detailData.cs_id = this.orignal_cs
      })

      // this.network().setTicketCs({
      //   cs_id: id
      // })
    },
    handlerContact(type) {
      this.contactType = type
      // this.$refs['contact-dialog'].changeDialog()
      if(type == 3){
        this.emailListTitle = this.detailData.url_list_title
        this.emailTitle = this.detailData.url_title
      }
      if(this.isNewSME)
        this.showSMS = true
      else
        this.$refs['send-email-sms'].changeDialog()
    },
    handlerEmailSmsSend(content,type,data) {
      let {referrer_send,referrer_content,customer_send} =data
      let params = {
        content,
        referrer_content,
        is_send: 1
      }
      if(!customer_send) delete params.content
      if(!referrer_send) delete params.referrer_content
      if(this.isPaidNoSignature || this.isPaidSignature) {
        this.network().signLinkSend(params)
        return
      }
      this.network().paymentLinkSend(params)
    },
    handlerEmailSmsSkip() {
      const params = {
        content: '',
        is_send: 0
      }
      if(this.isPaidNoSignature || this.isPaidSignature) {
        this.network().signLinkSend(params)
        return
      }
      this.network().paymentLinkSend(params)
    },
    initData() {
      this.showMain = true
      this.editStatus = false
      this.showPayment = false
    },
    viewPlan() {
      this.$refs['plan-dialog'].changeDialog()
    },
    viewCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.detailData.customer_id
        }
      })
    },
    openDialog(target) {
      if (target) {
        this.$refs[target].changeDialog()
      }
    },
    openRenewPdf(){
      let data = {}
      if(this.isDownloadPDF&&!this.isRenew){
        let {quotation_pdf} = this.detailData||{}
        data = quotation_pdf||{}
      }else {
        let {renew_file} = this.detailData||{}
        data = renew_file||{}
      }
      let {url} = data||{}
      if(url){
        window.open(url,'_blank')
      }
    },
    openInvoicePdf(){
      let data = {}
      let {inv_pdf} = this.detailData||{}
      data = inv_pdf||{}
      let {url} = data||{}
      if(url){
        window.open(url,'_blank')
      }
    },
    updateTicketsData(data) {
      this.handler().updateQuoteDetailData()
    },
    handlerEdit() {
      let {pre_unsettled_claims=[]} =this.detailData||{}
      if(this.isRenew && (this.hasEndorsNum || pre_unsettled_claims.length > 0)){
        this.showTips()
        return
      }
      this.showMain = false
      this.showPayment = false
      if(this.isRenew){
        this.detailData = {...this.detailData,...this.policyholderDetail}
        this.showKyc = true
      }else{
        this.editStatus = true
      }
    },
    showTips(){
      if(this.hasEndorsNum){
        this.$refs['endors-tips'].changeDialog()
      }
      if(this.pre_unsettled_claims.length > 0){
        this.$refs['claim-tips'].changeDialog()
      }
    },
    nextStep(step){
      this.step = step
      this.showTips()
    },

    tipsContinue(){
      if((this.$refs['endors-tips'].dialog == false) && (this.$refs['claim-tips'].dialog == false)){
        switch(this.step){
          case 1:
            this.showMain = false
            this.showKyc = true
            break
          case 2:
            this.$refs['edit-kyc'].continueAndNext()
            break
          case 3:
            this.$refs['edit-kyc'].$refs['reply'].onReferralSendSms(1)
        }
      }
    },
    handlerBuyQuote() {
      // this.showMain = false
      // this.editStatus = false
      // this.showPayment = true
      this.setCouponData(null)
      let {sme_versions} = this.$route.query
      this.$router.push({
        path: '/quoting/payment',
        // path: '/quoting/payment/success',
        query: {
          order_id: this.orderId,
          product_id: this.productId,
          quote_type: this.isRenew? 'renew': '',
          // sme_versions
        }
      })
    },
    async handlerSelectPlan(){
      let params = {
        order_id: this.orderId
      }
      const { data } = await getShareGuestQuote(params)
      this.setQuoteForm({
        ...this.detailData,
      })
      this.setAllQuote(data.list)
      this.setQuoteResult(data)
      let c_id = this.detailData.customer_id
      if(c_id){
        this.setSelectCustomerData(this.detailData.customer)
        this.$router.push({
          name: 'quotingQuote',
          query: {
            product_id: this.productId,
            order_id: this.orderId
          }
        })
      }else{
        this.$router.push({
          name: 'quotingCustomer',
          query: {
            order_id: this.orderId,
          }
        })
      }
    },
    handlerSetReferrerDiscount(){
      this.$refs['set-referrer-discount'].changeDialog()
    },
    handlerVoidQuote() {
      if(this.isPaidNoSignature||this.isPaidSignature){
        this.$refs['void-dialog'].changeDialog()
      }else
        this.$refs['void-quote'].changeDialog()
    },
    handlerVeiwPolicy(){
      let {sme_versions} = this.$route.query||{}
      this.$router.push({
        path: '/records/policy/detail',
        query: {
          id:this.orderId,
          product_id:this.productId,
          pcy_id:this.detailData.pcy_id,
        }
      })
    },
    handlerVoid(data){
      // let {sme_versions} = this.$route.query||{}
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id:data.order_id,
          product_id:this.productId,
          // sme_versions
        }
      })
      this.handler().getUpdateData()
    },
    async handlerSend(type){
      if(this.orderId && !type){
        await this.network().getQuoteUrl()
      }
      if(type){
        await this.network().getUrlData()
      }
      let textareaElement = document.createElement('textarea')
      textareaElement.setAttribute('readonly', 'readonly') // 防止弹出输入编辑
      textareaElement .value = this.quoteUrl
      document.body.appendChild(textareaElement )
      textareaElement .select() //选中textarea元素，以备调用系统copy函数复制其中的内容。
      let isSuccess = document.execCommand('copy')
      this.$NewMessageBox({
        title: 'Copy Link',
        message: 'The link has been copied to your clipboard',
        confirmBtn:'Done',
        btnType:'success'
      })
    },
    saveManual(){
      this.handler().getUpdateData()
    },
    handlerLock(lock) {
      this.network().setLockCustomer(lock)
      // if(lock==1){
      //   this.network().setLockCustomer(0)
      // }else {
      //   this.network().setLockCustomer(1)
      // }
    },
    remindCustomer(type){
      let params = {
        order_id: this.detailData.id,
        send_type: type
      }
      this.network().renewRemind(params)
    },
    onCopyKyc() {
      // 這裏要獲取報價
      if(this.isSMEProduct){
        this.setSmeQuickForm({
          ...this.detailData,
          copy: 1 // 標記是 copy kyc
        })
        this.setProductId(this.detailData.class_id)
        this.setEstimatedPremium(this.detailData.amount)
        this.setCustomerId(this.detailData.customer_id)
        this.$router.push('/quoting/customer/sme')
      }
      else
        this.network().getQuoteAllNew()
    },
    cancelEdit() {
      this.showKyc = false
      this.showMain = true
      this.step = 1
      this.handler().updateQuoteDetailData()
    },
    handlerSave(){
      this.cancelEdit()
    },
    handleUpdateDetail(){
      this.handler().updateQuoteDetailData()
    },
    getReferenceQuote(url){
      const {class_id, quo_id, company_id} = this.detailData.quote_coverage_list.plan_info
      let obj = this[`form${class_id}`]
      Object.keys(obj).forEach(key => {
        obj[key] = this.detailData[key]
      })
      const data = {
        class_id,
        quo_id,
        company_id,
        ...obj,
        merchant_platform:this.isFina?2:1
      }
      this.network().getQuoteReference(url,data)
    },
    setReferrerDiscount(params){
      this.network().setDiscount({
        ...params,
        order_id: this.orderId
      })
    },
    bankTransferSms(){
      this.$refs['bank-transfer-sms'].changeDialog()
    },
    handleUploadProof(){
      this.$refs['upload-bank-file'].changeDialog()
    },
    handleReview(){
      this.$refs['review-payment'].changeDialog()
    },
    handler() {
      return {
        deepQuoteDetail: () => {
          if(this.isPayment) return
          this.loading = true
          this.paymentQuoteTimer = setInterval(() => {
            this.handler().updateQuoteDetailData()
            if((Date.now()/1000) - this.clearTime >= 10 || this.isPayment) {
              this.loading = false
              clearInterval(this.paymentQuoteTimer)
            }
          }, 1000)
        },
        getUpdateData: () => {
          // 初始化并且從新獲取數據
          this.initData()
          this.network().getOrderLogList()
          if(this.productId>=80){
            // if(this.isNewSME)
            // {
            //   this.network().getNewSMEQuoteDetail()
            //   return
            // }
            // this.network().getSMEQuoteDetail()
            this.network().getNewSMEQuoteDetail()
            return
          }
          this.network().getCoressQuoteDetail()
        },
        updateQuoteDetailData: () => {
          if(this.productId>=80){
            // if(this.isNewSME)
            // {
            //   this.network().getNewSMEQuoteDetail()
            //   return
            // }
            this.network().getNewSMEQuoteDetail()
            // this.network().getSMEQuoteDetail()
            return
          }
          this.network().getCoressQuoteDetail({
            hideLoading: true
          })
        },
        handlerCancel: () => {
          this.initData()
        },
        handleBack: () => {
          this.showBuyQuoteContainer = false
          this.showMain = true
        },
        initStatusUpdateData: async () => {
          this.showBuyQuoteContainer = false
          this.showMain = true
          this.handler().getUpdateData()
        },
      }
    },
    network() {
      return {
        getNewSMEQuoteDetail:async ()=>{
          let {data} = await getNewSMEQuoteDetail({
            order_id:this.orderId
          })
          this.detailData = data
          this.orignal_cs = data.cs_id
          if (data.remark_list) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark_list))
          }
        },
        getSMEQuoteDetail:async ()=>{
          let {data} = await getSMEQuoteDetail({
            order_id:this.orderId
          },this.productId)
          this.detailData = data
          this.orignal_cs = data.cs_id
          if (data.remark_list) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark_list))
          }
        },
        getCoressQuoteDetail: async (params) => {
          const {data} = await getCoressQuoteDetail({
            order_id: this.orderId,
            ...params
          }, this.productId)
          this.detailData = data
          let {is_lock} = data || {}
          this.is_lock = is_lock
          this.orignal_cs = data.cs_id
          if (data.remark_list) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark_list))
          }
        },
        addAccountRemark: async () => {
          const {data} = await addAccountRemark({
            customer_id: this.detailData.customer_id,
            message: this.message
          })
          this.message = ''
          // todo 追加 remark
          this.remarkList.unshift(data)
        },
        setTicketCs: async params => {
          const {data} = await orderCsSet({
            order_id: this.orderId,
            ...params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        setLockCustomer: async params => {
          const {data} = await setLockCustomer({
            order_id: this.orderId,
            lock:params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.handler().getUpdateData()
        },
        orderSkip: async params => {
          const {data} = await orderSkip({
            order_id: this.orderId,
          })
          this.handler().getUpdateData()
        },
        getQuoteAllNew: async () => {
          this.setQuoteForm({
            ...this.detailData,
            copy: 1 // 標記是 copy kyc
          })

          if(this.isFina){
            this.setReferCustomerId(this.detailData.referrer_id)
            this.setSelectReferCustomerData(this.detailData.referrer)
          }else {
            this.setCustomerId(this.detailData.customer_id)
            this.setSelectCustomerData(this.detailData.customer)
          }
          this.setProductId(this.productId)
          this.setCarClassId(this.detailData.class_id)
          let serverType = this.isFina?'fina':'holdcover'
          if([13,21].includes(this.productId))
          {
            let { data } = await getQuoteAllNew(this.detailData)
            if(!data.list || data.list.length < 1) {
              this.$router.push({
                path:`/quoting/${serverType}/refer`,
                query: {
                  product_id: this.productId,
                  source:this.detailData.ref_agency_id
                }
              })
              return
            }
            this.setAllQuote(data.list)
            this.setQuoteResult(data)
            this.$router.push({
              path: `/quoting/${serverType}/quote`,
              query: {
                product_id: this.productId,
                source:this.detailData.ref_agency_id
              }
            })
          }else
            this.$router.push({
              path: `/quoting/${serverType}/underwriting`,
              query: {
                product_id: this.productId,
                source:this.detailData.ref_agency_id
              }
            })
        },
        paymentLinkSend: async (params = {}) => {
          const { data } = await paymentLinkSend({
            order_id: this.orderId,
            send_type: this.contactType == 1? 1: 2,
            ...params
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
          // this.$refs['send-email-sms'].changeDialog()
        },
        signLinkSend: async (params = {}) => {
          const { data } = await signLinkSend({
            order_id: this.orderId,
            send_type: this.contactType == 1? 1: 2,
            ...params
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
          // this.$refs['send-email-sms'].changeDialog()
        },
        getOrderLogList: async () => {
          const {data} = await getOrderLogList({
            order_id: this.orderId,
            page: this.pageConfig.currentPage,
          })
          this.logsData = data.data
        },
        renewRemind: async (params) => {
          const {data} = await renewRemind(params)
          const {code} = data
          if(code == 1000){
            this.handler().updateQuoteDetailData()
          }
        },
        renewSelectPlan: async (plan) => {
          let quo_id = plan.id
          let params = {
            quo_id,
            order_id: this.detailData.id
          }
          const { data } = await renewBuyPolicy(params)
          if(data.message == 'Success'){
            this.handler().updateQuoteDetailData()
          }
        },
        getQuoteReference: async (url, params) => {
          const res = await getQuoteReference(url, params)
          downloadFile(res)
        },
        getQuoteUrl: async () => {
          const {data} = await getQuoteUrl({
            order_id: this.orderId
          })
          this.quoteUrl = data.quote_url
        },
        setDiscount: async(params) => {
          const {data} = await setDiscount(params)
          const {code} = data
          if(code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$refs['set-referrer-discount'].handleCancel()
            this.handler().updateQuoteDetailData()
          }
        },
        getUrlData: async () => {
          const {data} = await getUrlData({
            order_id: this.orderId
          })
          this.quoteUrl = data.share_guest_bank_upload_url
        },
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
        },
        shareUserPolicy: async (params) => {
          const {data} = await shareUserPolicy({
            order_id:this.orderId,
            ...params
          })
          this.handler().updateQuoteDetailData()
          this.handleChangeLog()
        },
        removeShareUserPolicy: async () => {
          const {data} = await removeShareUserPolicy({
            order_id:this.orderId,
          })
          this.handler().updateQuoteDetailData()
          this.handleChangeLog()
        },
        downReferApplication: async () => {
          const {data} = await downReferApplication({
            order_id:this.orderId,
          })
          let {url} = data||{}
          window.open(url,'_blank')
        },
        addReferral: async (params) => {
          if(this.isFina){
            delete params.customer_id
          }
          let { data } = await addReferral({...params,order_id:this.orderId})
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.ticket_id
            }
          })
        },
        RebuildPDF: async (params) => {
          const {data} = await RebuildPDF(params)
          const {code} = data
          if(code === 1000){
            this.$message({
              type: 'success',
              message: data.message_language,
            })
          }
        },
        quoteSentStatus: async (params) => {
          const {data} = await quoteSentStatus(params)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../src/assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  min-height: 100%;
  padding-bottom: 40px;
  box-sizing: content-box;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }

  .span-status{
    color: #fff;
    padding: 2px 10px;
    border-radius: 100px;
    margin-right: 15px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .yellow{
    background-color: #DBAB09;
  }
  .red{
    border: 1px solid #CB2431;
    background: #fff;
    color: #D73A49;
  }
  .black{
    border: 1px solid #6A737D;
    background: #fff;
    color: #24292E;
  }
  .purple{
    background-color: #6F42C1;
  }
  .green{
    background: #28A745;
    color: white!important;
  }
  .orange {
    background: #E36209;
  }
  .void{
    background: #d73a49;
  }
  .main-container {
    padding: 0 88px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }
    .buy-quote-container{
      flex: 1;
    }
    .middle-col {
      flex: 1;
      min-width: 600px;

      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .renew_list{
        margin-bottom: 20px;
        p{
          align-items: center;
          cursor: pointer;
          margin-bottom: 10px;
          .icon{
            width: 22px;
            height: 22px;
            background: #E1E4E8;
            border-radius: 5px;
          }
          .money{
            color: #0366D6;
            font-weight: 400;
            font-size: 16px;
          }
          .amount_tag{
            padding: 3px 12px;
            border-radius: 100px;
            font-weight: 600;
            font-size: 12px;
            font-family: 'Inter';
            font-style: normal;
            margin-left: 15px;
            background: #FFFFFF;
            white-space: nowrap;
          }
          .tag_auto{
            border: 1px solid #0366D6;
            color: #0366D6;
          }
          .tag_terms{
            border: 1px solid #E1E4E8;
            color: #586069;
          }
          .active{
            font-weight: 600;
            font-size: 20px;
            color: #24292E;
          }
        }
        .cursor_default{
          cursor: default;
        }
        .btn{
          .el-button{
            flex: 1;
          }
        }
      }
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
        .status{
          color: #68C23A
        }
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        .percent{
          padding: 0px 6px;
          background: rgba(27, 31, 35, 0.08);
          border-radius: 100px;
          height: 16px;
          font-weight: 600;
          font-size: 12px;
          color: #586069;
          margin-left: 4px;
        }
      }
      .success{
        color: rgba(255, 255, 255, 1);
        background: rgba(46, 164, 79, 1);
      }
      .tr{
        display: flex;
        .mg-r-8{
          margin-right: 8px !important;
        }
      }
      .blue{
        color: #0366D6;
      }
      .bank-pay{
        margin-bottom: 10px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-bottom: 1px solid #dddfe7;

        .title {
          margin-bottom: 5px;
        }
      }

      .action-box {
        margin: 10px -15px 0 -15px;
        padding: 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;
      }

      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .amount-payable {
        border: 1px solid rgba(4,66,137,0.2);
        border-radius: 10px;
        background-color: #DBEDFF;
        //margin-bottom: 30px;
        &.border-b{
          margin-top: 0;
        }
        .title {
          margin-bottom: 0;
          padding-top: 15px;
          padding-bottom: 5px;
        }

        .amount {
          display: block;
          padding-bottom: 20px;
          font-size: 28px!important;
          color: #586069;
        }
        .payment-disblock{
          display: block!important;
          .size-blue{
            color: #0366D6;
            font-family: Inter;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .payment-status{
          display:flex ;
          justify-content: space-between;
          margin-bottom: 10px;
          .flex{
            align-items: center;
          }
          .dot{
            margin-right: 8px;
            display: block;
            border-radius: 50%;
            height: 16px;
            width: 16px;
            border: 1px solid rgba(0,0,0,0.2);
            background-color: #D73A49;
          }
          .green{
            background: #28A745!important;
          }
          .icon{
            margin-right: 5px;
          }
          .text-color{
            color: #0366D6;
            font-size: 12px;
          }
          .size-italic{
            font-style:italic;
            font-size: 12px;
            color: #6A737D;
          }
        }
        .tips{
          font-weight: 600;
          font-size: 14px;
          color: #24292E;
          margin: 20px 0 10px 0;
        }
        .send-color{
          color: #0366D6;
          font-size: 14px;
          font-weight: 500;
        }
        .button-list{
          margin: 20px 0;
          .el-button{
            margin-right: 8px;
            width: 50%;
            font-size: 14px;
          }
        }

      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

    }
  }

  .dialog-container {
    padding-left: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .mt-10{
    margin-top: 10px;
    display: inline-block;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 88px 0px 88px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
  .pdb-10{
    padding-bottom: 10px;
  }
}
span.edit{
  color: #0366D6;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.description-content{
  font-weight: 400;
  font-size: 14px;
  color: #24292E;
  margin-bottom: 15px;
  &.mg-b-0{
    margin-bottom: 0;
  }
}
.text-throught-line{
  text-decoration: line-through;
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}

.pd-40{
  padding: 20px 88px;
}
</style>
